export default __webpack_public_path__ + "static/media/hero.7819d159.avif";